export default __webpack_public_path__ + "static/media/folder-empty.ddb0fb8e.svg";